webpackJsonp([44196145187064],{

/***/ 626:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookRouter = __webpack_require__(64);
	
	var _LoreHookRouter2 = _interopRequireDefault(_LoreHookRouter);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookRouter2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'routes'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Returns the routes used by the application.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore.loader'
	      ),
	      ' object is a way of lazy-loading files and directories the framework doesn\'t have control over such as the models, config directory, and in this case the routes.js file at the root of the project.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The reason the loader is used here is because the routes ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'must'
	      ),
	      ' to be lazy-loaded, since loading the routes will pull in the components, which may be using the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore.connect'
	      ),
	      ' decorator that won\'t exist until the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore.connect'
	      ),
	      ' hooks loads.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Trying to load the routes directly in this config file will throw an error during build, because lore loads the config file ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'before'
	      ),
	      ' any of the hooks, since they need information in the config to determine their behavior.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      routes: function(lore) {\n        return lore.loader.loadRoutes();\n      }\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-router-config-routes-js-dccd2935128fdcf7770d.js